import { ComponentProps } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { TextWrapperProps } from '../ParameterizedText/ParameterizedText.types';
import { titleHeight } from './HeaderSection.ve.css';

export const headerSectionCommonPadding: ComponentProps<typeof Stack> = {
    paddingLeft: { default: '6', sm: '8' },
    paddingRight: { default: '6', sm: '8' },
};

export const titleProps: TextWrapperProps = {
    className: titleHeight,
    as: 'h2',
    size: {
        default: 'h_lg',
        sm: 'h_xl',
    },
    fontWeight: 'bold',
    'data-testid': 'personalized-title',
};
